import React from "react";
import Modal from "../common/Modal";

// Placeholder size chart. Measurements are NOT official — replace with real
// garment measurements before launch.
const ROWS = [
  { size: "S", chest: "38", length: "27", shoulder: "17" },
  { size: "M", chest: "40", length: "28", shoulder: "18" },
  { size: "L", chest: "42", length: "29", shoulder: "19" },
  { size: "XL", chest: "44", length: "30", shoulder: "20" },
  { size: "XXL", chest: "46", length: "31", shoulder: "21" },
];

const SizeGuideModal = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose} title="Size Guide" size="md" testId="size-guide-modal">
    <p className="mb-4 font-mono text-[11px] uppercase tracking-wider text-ink/50">
      Placeholder measurements (inches) — to be confirmed
    </p>
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-ink">
            {["Size", "Chest", "Length", "Shoulder"].map((h) => (
              <th key={h} className="label-mono py-3 text-left">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r) => (
            <tr key={r.size} className="border-b border-ink/10">
              <td className="py-3 font-mono font-medium">{r.size}</td>
              <td className="py-3 font-mono text-ink/70">{r.chest}"</td>
              <td className="py-3 font-mono text-ink/70">{r.length}"</td>
              <td className="py-3 font-mono text-ink/70">{r.shoulder}"</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p className="mt-5 text-xs leading-relaxed text-ink/50">
      How to measure: lay a similar t-shirt flat and measure across. Chest is
      measured pit-to-pit. If you're between sizes, size up for an oversized fit.
      Final measurements will be updated with real product specifications.
    </p>
  </Modal>
);

export default SizeGuideModal;
